import React from 'react';

const TONES = {
  gray: 'bg-gray-100 text-gray-700 dark:bg-white/[0.08] dark:text-gray-200',
  brand: 'bg-primary-50 text-primary-700 dark:bg-primary-400/15 dark:text-primary-300',
  solid: 'bg-primary-600 text-white',
};
const SIZES = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-8 w-8 text-[11px]',
  md: 'h-10 w-10 text-[13px]',
};

export const initialsOf = (name = '') =>
  String(name)
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();

// Round initials or icon badge for a person (FECOA-2174).
const Avatar = ({ name, icon: Icon, size = 'sm', tone = 'gray', className = '' }) => (
  <span
    className={`inline-flex flex-shrink-0 items-center justify-center rounded-full font-semibold ${SIZES[size] || SIZES.sm} ${TONES[tone] || TONES.gray} ${className}`}
    aria-hidden="true"
  >
    {Icon ? <Icon className="h-[45%] w-[45%]" strokeWidth={1.75} /> : initialsOf(name) || '?'}
  </span>
);

export default Avatar;
